import { render, staticRenderFns } from "./RPaper.vue?vue&type=template&id=7fe1b7ce&scoped=true"
import script from "./RPaper.vue?vue&type=script&lang=js"
export * from "./RPaper.vue?vue&type=script&lang=js"
import style0 from "./RPaper.vue?vue&type=style&index=0&id=7fe1b7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1b7ce",
  null
  
)

export default component.exports